import type { ReadinessIssue, ReadinessSeverity } from "./integrationsBeta";

// Settings tab values (SettingsPanel section state).
export type SettingsSection =
  | "status"
  | "connections"
  | "steps"
  | "integration_config"
  | "execution"
  // Slack run-status cards on/off. No readiness issue maps here.
  | "notifications"
  | "webhooks"
  | "schedules"
  // Irreversible actions. No readiness issue maps here, so the tab never
  // shows a badge; it is superuser-only and nothing stages into it.
  | "danger";

const SCOPE_TO_SECTION: Record<ReadinessIssue["scope"], SettingsSection> = {
  integration: "integration_config",
  step: "steps",
  connection: "connections",
  webhook: "webhooks",
  schedule: "schedules",
};

export function sectionForIssue(issue: ReadinessIssue): SettingsSection {
  // Step-scoped issues (incl. wrong bindings) are fixed on the Steps tab;
  // connection-scoped ones (missing credential, bad config) on Connections.
  return SCOPE_TO_SECTION[issue.scope] ?? "status";
}

export function issuesBySection(
  issues: ReadinessIssue[] | undefined,
): Partial<Record<SettingsSection, ReadinessIssue[]>> {
  const grouped: Partial<Record<SettingsSection, ReadinessIssue[]>> = {};
  (issues ?? []).forEach((issue) => {
    const section = sectionForIssue(issue);
    (grouped[section] ??= []).push(issue);
  });
  return grouped;
}

export function worstSeverity(
  issues: ReadinessIssue[] | undefined,
): ReadinessSeverity | null {
  if (!issues || issues.length === 0) return null;
  return issues.some((issue) => issue.severity === "error")
    ? "error"
    : "warning";
}
